import axios from 'axios';

export default axios.create({
    baseURL:"https://contactmanagerbackend-or11.onrender.com/",
})